import _ from 'lodash'
import {
    READ_TOKENS_FROM_FORAGE,
    RESET_TOKENS,
    SET_TOKENS,
    // SET_ACCESSTOKEN,
    // SET_REFRESHTOKEN,
    REMOVE_TOKENS,
} from './constants'
import { USERS_LOGIN_USER, USERS_FORGET_USERS, USERS_LOGOUT_USER } from '../constants'

// Initial state for users in the store
const initialState = {}
// const initialState  = {
//     tq: { testuser_1: { access: '', refresh: ''} },
//     sisi: {},
// }

const add = (state, serverId, userId, tokens) =>
    // Update the user in the list
    ({
        ...state,
        [serverId]: {
            ...(state[serverId] || {}),
            [userId]: tokens,
        },
    })

const remove = (state, serverId, userId) => {
    // User is not in state
    if (state[serverId] == null || state[serverId][userId] == null) {
        return state
    }

    // Remove the user
    return {
        ...state,
        [serverId]: _.omit(state[serverId], userId),
    }
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Read the users tokens from forage
        case READ_TOKENS_FROM_FORAGE:
            return action.payload

        // Remove all tokens
        case RESET_TOKENS:
        case USERS_FORGET_USERS:
            return {}

        case USERS_LOGIN_USER: {
            const { serverId, user: { userId, tokens } } = action.payload
            return add(state, serverId, userId, tokens)
        }

        // Set tokens for a user
        case SET_TOKENS: {
            const { serverId, userId, tokens } = action.payload
            return add(state, serverId, userId, tokens)
        }

        // // Set access token for a user
        // case SET_ACCESSTOKEN: {
        //     const { serverId, userId, accessToken } = action.payload

        //     const tokens = (state[serverId] || {})[userId] || {}
        //     tokens.access = accessToken

        //     // Update the user in the list
        //     return {
        //         ...state,
        //         [serverId]: {
        //             ...(state[serverId] || {}),
        //             [userId]: tokens,
        //         },
        //     }
        // }

        // // Set refresh token for a user
        // case SET_REFRESHTOKEN: {
        //     const { serverId, userId, refreshToken } = action.payload

        //     const tokens = (state[serverId] || {})[userId] || {}
        //     tokens.refresh = refreshToken

        //     // Update the user in the list
        //     return {
        //         ...state,
        //         [serverId]: {
        //             ...(state[serverId] || {}),
        //             [userId]: tokens,
        //         },
        //     }
        // }

        // Remove tokens from a user
        case USERS_LOGOUT_USER:
        case REMOVE_TOKENS: {
            const { serverId, userId } = action.payload
            return remove(state, serverId, userId)
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Users/data/tokens/reducer.js